module.exports = __webpack_public_path__ + "img/dsci0059.c4e955a4.jpg";